{
  "name": "utms-admin-dashboard",
  "version": "1.5.10",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "prestart:prod": "npm --no-git-tag-version version minor",
    "start:prod": "ng serve --configuration production-eu",
    "update-build-timestamp": "node updateBuildTimestamp.js",
    "start-na": "ng serve --configuration local-na",
    "build": "ng build",
    "build-prod-eu": "ng build  --configuration production-eu",
    "build-dev-eu": "npm run update-build-timestamp && ng build  --configuration development-eu",
    "watch": "ng build --watch --configuration development-eu",
    "build-prod-na": "ng build --configuration production-na",
    "build-dev-na": "ng build --configuration development-na",
    "build-na": "ng build --configuration local-na",
    "test": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.26",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^20.3.26",
    "@angular/compiler": "^20.3.26",
    "@angular/core": "^20.3.26",
    "@angular/forms": "^20.3.26",
    "@angular/google-maps": "^19.2.19",
    "@angular/material": "^20.2.14",
    "@angular/material-moment-adapter": "^20.2.14",
    "@angular/platform-browser": "^20.3.26",
    "@angular/platform-browser-dynamic": "^20.3.26",
    "@angular/router": "^20.3.26",
    "@azure/msal-angular": "^4.1.1",
    "@azure/msal-browser": "^4.30.0",
    "@json2csv/node": "^7.0.1",
    "@sentry/angular": "^10.65.0",
    "exceljs": "^4.4.0",
    "msal": "^1.4.17",
    "rxjs": "~7.8.1",
    "tslib": "^2.8.1",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.3.32",
    "@angular/cli": "^20.3.32",
    "@angular/compiler-cli": "^20.3.26",
    "@types/google.maps": "3.64.0",
    "@types/jasmine": "^4.6.6",
    "@types/node": "^22.20.1",
    "jasmine-core": "~4.5.0",
    "karma": "^6.4.1",
    "karma-chrome-launcher": "~3.1.1",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.0.0",
    "patch-package": "^8.0.1",
    "typescript": "^5.9.3"
  },
  "engines": {
    "npm": "^12.0.0",
    "node": ">=22.16.0"
  }
}
